import { Link, useParams } from "react-router-dom";
import type { MatterDetailRow } from "@themislex/shared";
import { useApi } from "../../api/hooks";
import { InvoiceTable } from "../../components/InvoiceTable";
import { MatterInfoCard } from "../../components/MatterInfoCard";
import { Card, ErrorNote, PageHeader, Spinner } from "../../components/ui";

export default function ClientMatterDetail() {
  const { id = "" } = useParams();
  const { data, error, loading } = useApi<{ matter: MatterDetailRow }>(
    `/api/matters/${id}`,
  );

  if (loading) {
    return (
      <div className="flex justify-center py-16 text-muted">
        <Spinner className="h-6 w-6" />
      </div>
    );
  }
  if (error || !data) {
    return <ErrorNote>{error ?? "Matter not found."}</ErrorNote>;
  }

  const matter = data.matter;

  return (
    <>
      <PageHeader title="Matter details" subtitle="Maintained by the chambers." />

      <MatterInfoCard matter={matter} />

      <div className="mt-8">
        <Card
          title="Invoices for this matter"
          actions={
            <Link to="/portal/invoices" className="btn btn-ghost px-2 py-1 text-xs">
              All my invoices
            </Link>
          }
        >
          <InvoiceTable
            invoices={matter.invoices}
            emptyHint="No invoices have been raised for this matter."
          />
          <p className="mt-4 text-xs text-muted">
            Invoice PDFs include the chambers' UPI QR code for direct payment.
          </p>
        </Card>
      </div>
    </>
  );
}
